import React from "react";
import {
  LogoLoader,
  Skeleton,
  DotLoader,
  CircleLoader,
} from "../../../../components";

const Loading = () => {
  return (
    <div>
      <div className="flex justify-center p-20">
        <CircleLoader />
      </div>
      <div className="flex justify-center p-20">
        <DotLoader />
      </div>
      <div className="flex flex-col gap-6">
        <Skeleton variant="text" size="md" />

        <Skeleton variant="paragraph" lines={4} />

        <Skeleton variant="circle" size="xl" />

        <Skeleton variant="rectangle" size="lg" />

        <Skeleton variant="image" size="xs" animation="pulse" />
      </div>
      <div className="flex justify-center p-20">
        <LogoLoader />
      </div>
    </div>
  );
};

export default Loading;
